import ErrorAlert from "@/utility/ErrorAlert";
import http from "@/axios/http-common";
import { isEmpty } from "lodash";

async function create(data) {
  const response = await http
    .postData("/survey-primer-igd", data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data?.data ?? null;
}

async function update(id, data) {
  const response = await http
    .putData(`/survey-primer-igd/${id}`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data?.data ?? null;
}

async function getByRegister(register_id: string | number) {
  const response = await http
    .getData(`/register/${register_id}/survey-primer-igd`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data?.data ?? null;
}

async function getRiwayat(register_id: string | number) {
  const response = await http
    .getData(`/register/${register_id}/survey-primer-igd/riwayat`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data?.data ?? [];
}

async function syncTriase(register_id: string | number, triage_id: number) {
  const response = await http
    .putData(`/register/${register_id}/igd-triase`, { triage_id })
    .catch(() => null);

  return response?.data ?? null;
}

async function find(id: number) {
  const response = await http.getData(`/survey-primer-igd/${id}`).catch(err => {
    ErrorAlert.showErrorAlert(err);

    return Promise.reject(err);
  });

  return response.data?.data ?? null;
}

async function destroy(id: number) {
  const response = await http
    .deleteData(`/survey-primer-igd/${id}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  const data = isEmpty(response?.data) ? null : response.data;

  return data;
}

export default {
  create,
  update,
  getByRegister,
  getRiwayat,
  syncTriase,
  find,
  destroy
};
